import { PatientTableInfoEntity } from "@/domain/entity/patient/patient-table-info-entity";
import { PatientRepository } from "@/domain/repository/patient-repository";
import { TimedCache } from "@/utils/cache/timed-cache";
import { SATError, SATResult } from "@sadtx/sat-error";

export class FetchPatientListUsecase {
  //MARK: - Constructor
  constructor(
    private readonly patientRepository: PatientRepository,
    private readonly cache?: TimedCache<SATResult<PatientTableInfoEntity[], SATError>>
  ) {}

  async execute(): Promise<SATResult<PatientTableInfoEntity[], SATError>> {
    // 캐시가 주입되면 짧은 시간 내 반복 조회를 재사용 (새로고침 시에는 메모리가 비어 항상 새로 조회)
    const result = this.cache
      ? await this.cache.getOrLoad(
          () => this.patientRepository.fetchPatientList(),
          (loaded) => loaded.isSuccess
        )
      : await this.patientRepository.fetchPatientList();
    if (result.isFailure) {
      return SATResult.failure(result.error);
    }
    return SATResult.success(result.value!);
  }
}
